"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeTraits = exports.getPrincipal = exports.wrap = void 0;
const principal_1 = require("@dfinity/principal");
function wrap(optional) {
    if (!optional) {
        return [];
    }
    return [optional];
}
exports.wrap = wrap;
function getPrincipal(id) {
    if (!id) {
        return null;
    }
    if (typeof id === 'string') {
        return principal_1.Principal.fromText(id);
    }
    return id;
}
exports.getPrincipal = getPrincipal;
const serializeTraits = (traits) => {
    if (!traits || !Object.keys(traits).length)
        return undefined;
    return Object.entries(traits).reduce((result, [key, values]) => {
        const traitValues = values.map((value) => ({ TextContent: value }));
        result.push([key, traitValues]);
        return result;
    }, []);
};
exports.serializeTraits = serializeTraits;
